export const statusList = {
  name: 'statusList',
  data () {
    return {
      statusList: [],
      statusName: 'All'
    }
  },
  methods: {
    getStatusList: function () {
      // first check if list is in sessionStorage
      if (sessionStorage.getItem('statusList')) {
        this.statusList = JSON.parse(sessionStorage.getItem('statusList'))
      } else {
        // get from api, and save to sessionStorage
        this.getStatusFromAPI()
      }
    },
    getStatusFromAPI: function () {
      var call = '/getPEAStatusList'
      this.$axios.get(call).then(response => {
        this.statusList = response.data
        this.statusList.push({'id': 0, 'description': 'All'})
        // write to sessionStorage
        sessionStorage.setItem('statusList', JSON.stringify(response.data))
      }).catch(reject => {
        // not able to get to screen
      })
    }
  },
  beforeUpdate: function () {
    this.getStatusList()
  }
}
